<template>
  <div class="flex gap-2 flex-wrap">
    <interview-category-item
      v-for="category in props.categories"
      :key="category?.slug"
      :category="category"
      :is-selected="props.categorySelected === category.slug"
      :path="`${props.topicSelected}/${category.slug}`"
    />
  </div>
</template>

<script lang="ts" setup>
import { TCategory } from 'features/categories'

type Props = {
  categories: TCategory[] | null
  topicSelected: string
  categorySelected: string
}

const props = withDefaults(defineProps<Props>(), {
  categories: () => [],
  topicSelected: '',
  categorySelected: '',
})
</script>
